import { Navitem } from '@app/shell/navitems';
import { Betreuer, RightsConst, Vertreter } from '@pezi/entities';

export function vertreterDetailNavItems(vertreter: Vertreter, dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Vertreterdaten',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Versicherungsbestätigung',
      routerUrl:      '/versbestaetigung',
      hidden:         true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Buchungszeilen',
      routerUrl:      '/buchungszeilen',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Buchungen',
      routerUrl:      '/buchungen',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Briefe',
      routerUrl:      '/briefe',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Termine',
      routerUrl:      '/termine',
      dynamicURLPart: dynamicUrlPart,
      hidden:         !vertreter.showTermine
    },
    {
      name:           'Zahlungen',
      routerUrl:      '/zahlungen',
      dynamicURLPart: dynamicUrlPart,
      right:          RightsConst.PZ_VERTRETER_BUC
    },
    {
      name:           'Todo',
      routerUrl:      '/todo',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function bezugsberechtigterDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Übersicht',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Polizzen',
      routerUrl:      '/polizzen',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function fahrzeugDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Fahrzeugdaten',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function gebaeudeDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Gebäudedaten',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function vsbDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Übersicht',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function verbundDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Verbunddaten',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Risikoabdeckung',
      routerUrl:      '/risikoabdeckung',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Schadensatz',
      routerUrl:      '/schadensatz',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Polizzen',
      routerUrl:      '/polizzen',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Kommunikation',
      routerUrl:      '/kommunikation',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function betreuerDetailNavItems(betreuer: Betreuer, version?: string): Navitem[] {

  let urlpart: string;
  if (version && version !== '1') {
    urlpart = '/betreuer/' + betreuer.person.id + '/version/' + version;
  } else {
    urlpart = '/betreuer/' + betreuer.person.id;
  }

  return [
    {
      name:           'Übersicht',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: urlpart
    },
    {
      name:           'Vertreter',
      routerUrl:      '/vertreter',
      dynamicURLPart: urlpart
    },
    {
      name:           'Rabattkonto',
      routerUrl:      '/rabattkonto',
      dynamicURLPart: urlpart,
      hidden:         !betreuer.rabattkontoTab
    },
    {
      name:           'Schadensatz',
      routerUrl:      '/schadensatz',
      dynamicURLPart: urlpart,
      hidden:         !betreuer.schadensatzTab
    },
    {
      name:           'Termine',
      routerUrl:      '/termine',
      dynamicURLPart: urlpart,
      hidden:         !betreuer.showTermine
    }
  ];
}

export function hotlineDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Übersicht',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function maklerpersonDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Übersicht',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Polizzen',
      routerUrl:      '/polizzen',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:      'Bankverbindungen',
      routerUrl: '/zahlungen',
      dynamicURLPart: dynamicUrlPart,
      right:     RightsConst.PZ_MAKLER_PERBANK
    },
    {
      name:           'Schaden',
      routerUrl:      '/schaden',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:      'Mailings',
      routerUrl: '/mailings',
      dynamicURLPart: dynamicUrlPart,
      right:     RightsConst.PZ_MAKLER_PERMAILING
    }
  ];
}

export function maklerpolizzeDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Übersicht',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Personen/Objekte',
      routerUrl:      '/objekte',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Polizzentext',
      routerUrl:      '/polizzentext',
      dynamicURLPart: dynamicUrlPart,
      right:          RightsConst.PZ_MAKLER_STATUSDRUCK
    },
    {
      name:           'Schäden',
      routerUrl:      '/schaden',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:      'Provisionen',
      routerUrl: '/provisionen',
      dynamicURLPart: dynamicUrlPart,
      right:     RightsConst.PZ_MAKLER_PROVISION
    },
    {
      name: 'Inkasso',
      routerUrl:      '/inkasso',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:      'Klauseln/BB',
      routerUrl: '/klauseln',
      dynamicURLPart: dynamicUrlPart,
      right:     RightsConst.PZ_MAKLER_KLAUSEL
    },
    {
      name:           'Änderungen',
      routerUrl:      '/aenderungen',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:      'Freie Rabatte/Zuschläge',
      routerUrl: '/freie-rabatte',
      dynamicURLPart: dynamicUrlPart,
      right:     RightsConst.PZ_MAKLER_POL_RABATTE
    },
    {
      name:           'Dokumente',
      routerUrl:      '/documents',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:      'Termine',
      routerUrl: '/termine',
      dynamicURLPart: dynamicUrlPart,
      right:     RightsConst.PZ_MAKLER_TERMINE
    },
    {
      name:      'Referate',
      routerUrl: '/referate',
      dynamicURLPart: dynamicUrlPart,
      right:     RightsConst.PZ_MAKLER_POL_REF
    }
  ];
}

export function maklerschadenDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Übersicht',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Beteiligte',
      routerUrl:      '/beteiligte',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Zahlungen',
      routerUrl:      '/zahlungen',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function ungeklaerteZahlungenArchivDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Übersicht(Archiv)',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function maklervertreterDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Übersicht',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function beitragszahlerDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Übersicht',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Polizzen',
      routerUrl:      '/polizzen',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Schäden',
      routerUrl:      '/schaden',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function versichertepersonDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Übersicht',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Polizzen',
      routerUrl:      '/polizzen',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Schäden',
      routerUrl:      '/schaden',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function betreuerknotenDetailNavItems(dynamicUrlPart: string, betreuer: Betreuer): Navitem[] {
  return [
    {
      name:           'Übersicht',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Betreuer',
      routerUrl:      '/betreuer',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Schadensatz',
      routerUrl:      '/schadensatz',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Boni',
      routerUrl:      '/boni',
      dynamicURLPart: dynamicUrlPart,
      hidden:         !betreuer.showBoni
    }
  ];
}

export function textDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Übersicht',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function familienpassDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Übersicht',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Polizzen',
      routerUrl:      '/polizzen',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Schäden',
      routerUrl:      '/schaden',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function partnerDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Übersicht',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function maklerDLNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Bestandszuwachs',
      routerUrl:      '/list',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'OMDS',
      routerUrl:      '/list/omds',
      dynamicURLPart: dynamicUrlPart,
      right:          RightsConst.PZ_MAKLER_OMDS
    },
    {
      name:           'Bedingungen',
      routerUrl:      '/list/bedingungen',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Produkt- und Basisinformationsblätter',
      routerUrl:      '/list/produktdatenblatt',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Dokumente',
      routerUrl:      '/list/dokumente',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'IDD',
      routerUrl:      '/list/idd',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function cmsNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Zuweisung',
      routerUrl:      '/maklerdoc',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function zulassungKennzeichenNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Archiv',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function schadenzahlungempfDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Übersicht',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Kontakt',
      routerUrl:      '/kontakt',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Schäden',
      routerUrl:      '/schaden',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function schadenbeteiligterDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Schäden',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Übersicht',
      routerUrl:      '/uebersicht',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function zulassungDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Übersicht',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Archiv',
      routerUrl:      '/archiv',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Historie',
      routerUrl:      '/historie',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function haushaltDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Haushaltsdaten',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Risikoabdeckung',
      routerUrl:      '/risikoabdeckung',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Schadensatz',
      routerUrl:      '/schadensatz',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Polizzen',
      routerUrl:      '/polizzen',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Kommunikation',
      routerUrl:      '/kommunikation',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function schadenDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Schadendaten',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Beteiligte',
      routerUrl:      '/beteiligte',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Briefe',
      routerUrl:      '/briefe',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Termine',
      routerUrl:      '/termine',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Zahlungen',
      routerUrl:      '/zahlungen',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Buchungen',
      routerUrl:      '/buchungen',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Benachrichtigung zum Schaden',
      routerUrl:      '/elekkomm',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Checklisten',
      routerUrl:      '/checkliste',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Feedback',
      routerUrl:      '/feedback',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function personDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Personendaten',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Polizzen',
      routerUrl:      '/polizzen',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Kundensegment',
      routerUrl:      '/kundensegment',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Kontakt',
      routerUrl:      '/kommunikation',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Bank/Zahlungen',
      routerUrl:      '/zahlungen',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Schaden',
      routerUrl:      '/schaeden',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Elek. Kommunikation',
      routerUrl:      '/elekkomm',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Dokumente',
      routerUrl:      '/documents',
      dynamicURLPart: dynamicUrlPart,
      right:          RightsConst.PZ_PDO
    },
    {
      name:           'Vollmachten',
      routerUrl:      '/vollmacht',
      dynamicURLPart: dynamicUrlPart,
      right:          RightsConst.PZ_PVM
    },
    {
      name:           'Referate',
      routerUrl:      '/referate',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Mailings',
      routerUrl:      '/mailings',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Todo',
      routerUrl:      '/todo',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function assistanceDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Personendaten',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function polDetailLocked(dynamicUrlPart: string): Navitem {
  return {
    name:           'Keine Einsicht',
    routerUrl:      '/',
    icon:           'info',
    isDefault:      true,
    dynamicURLPart: dynamicUrlPart
  };
}

export function polDetailFFNavItem(dynamicUrlPart: string): Navitem {
  return {
    name:           'Fremde Führung',
    routerUrl:      '/fremdefuehrung',
    dynamicURLPart: dynamicUrlPart
  };
}

export function polDetailTexteNavItem(dynamicUrlPart: string): Navitem {
  return {
    name:           'Texte',
    routerUrl:      '/texte',
    dynamicURLPart: dynamicUrlPart
  };
}

export function polDetailAchtungNavItem(dynamicUrlPart: string): Navitem {
  return {
    name:           'Achtung',
    routerUrl:      '/achtung',
    dynamicURLPart: dynamicUrlPart
  };
}

export function polDetailRendementNavItem(dynamicUrlPart: string): Navitem {
  return {
    name:           'Rendement',
    routerUrl:      '/rendement',
    dynamicURLPart: dynamicUrlPart
  };
}

export function polDetailLebentNavItem(dynamicUrlPart: string): Navitem {
  return {
    name:           'LV-Übersicht',
    routerUrl:      '/leben',
    dynamicURLPart: dynamicUrlPart
  };
}

export function polDetailGenehmigungenNavItem(dynamicUrlPart: string): Navitem {
  return {
    name:           'Genehmigungen',
    routerUrl:      '/genehmigungen',
    dynamicURLPart: dynamicUrlPart
  };
}

export function polDetailRabattkontoNavItem(dynamicUrlPart: string): Navitem {
  return {
    name:           'Rabattkonto',
    routerUrl:      '/rabattkonto',
    dynamicURLPart: dynamicUrlPart
  };
}

export function polFondPlusNavItem(dynamicUrlPart: string): Navitem {
  return {
    name:           'Plus2',
    routerUrl:      '/fondplus',
    dynamicURLPart: dynamicUrlPart
  };
}

export function polDFZNavItem(dynamicUrlPart: string): Navitem {
  return {
    name:           'DFZ',
    routerUrl:      '/dfz',
    dynamicURLPart: dynamicUrlPart
  };
}

export function polFamilienpassItem(dynamicUrlPart: string): Navitem {
  return {
    name:           'XML-Daten',
    routerUrl:      '/familienpass',
    dynamicURLPart: dynamicUrlPart
  };
}

export function vertragNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Vertragsübersicht',
      routerUrl:      '/',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Personen/Objekte',
      routerUrl:      '/objekte',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function positionsNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Positionsübersicht',
      routerUrl:      '/',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Personen/Objekte',
      routerUrl:      '/objekte',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function zahlungsNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Zahlungsdetails',
      routerUrl:      '/',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function buchungsNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Buchungsdetails',
      routerUrl:      '/',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function referatAdminNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Buchstabenzuteilung',
      routerUrl:      '/',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Zuteilungsregeln',
      routerUrl:      '/zuteilungsregeln',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function betreuerdatenadminNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Provisionsaufteilung (SUA)',
      routerUrl:      '/',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:      'Stockübertrag (SUT)',
      routerUrl: '/stockuebertrag',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Bonifikation',
      routerUrl:      '/zielboni',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Bestandsprovision',
      routerUrl:      '/zielprov',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function schadendatenadminNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name: 'Externe Sachverständigen-Zahlungen',
      routerUrl: '/',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Interne Sachverständigen-Zahlungen',
      routerUrl:      '/intern',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function polDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Polizzendaten',
      routerUrl:      '/',
      icon:           'info',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Personen/Objekte',
      routerUrl:      '/objekte',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Polizzentext',
      routerUrl:      '/polizzentext',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Buchungen/Inkasso',
      routerUrl:      '/buchungen',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Klauseln/BB',
      routerUrl:      '/klauseln',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Schäden',
      routerUrl:      '/schaden',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Provisionen',
      routerUrl:      '/provisionen',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Änderungen',
      routerUrl:      '/aenderungen',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Freie Rabatte/Zuschläge',
      routerUrl:      '/freie-rabatte',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Briefe',
      routerUrl:      '/briefe',
      dynamicURLPart: dynamicUrlPart
    },/*
    {
      name:           'Druck',
      routerUrl:      '/druck',
      dynamicURLPart: dynamicUrlPart
    },*/
    {
      name:           'Termine',
      routerUrl:      '/termine',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Zusatzangaben',
      routerUrl:      '/zusatzangaben',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Todo',
      routerUrl:      '/todo',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Referate',
      routerUrl:      '/referate',
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Esign',
      routerUrl:      '/esign',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function schadenDeckungsbedenken(dynamicUrlPart: string): Navitem {
  return {
    name:           'Deckungsbedenken',
    routerUrl:      '/deckungsbedenken',
    dynamicURLPart: dynamicUrlPart
  };
}

export function schadenDetailLocked(dynamicUrlPart: string): Navitem {
  return {
    name:           'Keine Einsicht',
    routerUrl:      '/',
    icon:           'info',
    isDefault:      true,
    dynamicURLPart: dynamicUrlPart
  };
}

export function personDetailLocked(dynamicUrlPart: string): Navitem {
  return {
    name:           'Keine Einsicht',
    routerUrl:      '/',
    icon:           'info',
    isDefault:      true,
    dynamicURLPart: dynamicUrlPart
  };
}

export function userAdminDetailNavItems(dynamicUrlPart: string): Navitem[] {
  return [
    {
      name:           'Benutzerdetail',
      routerUrl:      '/',
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Benutzerrechte',
      routerUrl:      '/rights',
      dynamicURLPart: dynamicUrlPart
    }
  ];
}

export function kundenAdminNavItems(dynamicUrlPart: string, id: string): Navitem[] {
  return [
    {
      name:           'Kunden ersetzen',
      routerUrl:      '/ersetzen/' + id,
      isDefault:      true,
      dynamicURLPart: dynamicUrlPart
    },
    {
      name:           'Kundenverbund',
      routerUrl:      '/verbund/' + id,
      dynamicURLPart: dynamicUrlPart
    }
  ];
}
